// The nested check/condition builder for the Operational Checks tab. Maps
// straight onto LoanTapeSettings.operational_checks (list[OperationalCheck])
// in preflight.py - CashFlows has no operational_checks field, so this is
// only ever wired to draft.loantape.operational_checks from SettingsPage.
// Mirrors reporting-hub's OperationalChecksBuilder.tsx.

import React from 'react';
import { Button } from 'primereact/button';
import OperationalCheckItem from './OperationalCheckItem';

// crypto.randomUUID() is available in all evergreen browsers exaport targets
// (same assumption reporting-hub's own builder makes); the backend replaces
// this with its own uuid4 anyway if the id were ever omitted, this is just
// for React keys / this-session stability.
const newId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `check-${Date.now()}-${Math.random()}`;

const OperationalChecksBuilder = ({ checks, onChange }) => {
  const updateCheck = (idx, updated) => {
    onChange(checks.map((c, i) => (i === idx ? updated : c)));
  };

  const removeCheck = (idx) => {
    onChange(checks.filter((_, i) => i !== idx));
  };

  const addCheck = () => {
    onChange([
      ...checks,
      { id: newId(), name: '', conditions: [{ column: '', operator: '==', value: '', connector: null }] },
    ]);
  };

  return (
    <div>
      <div>
        {checks.map((check, idx) => (
          <OperationalCheckItem key={check.id} check={check} onChange={(updated) => updateCheck(idx, updated)} onRemove={() => removeCheck(idx)} />
        ))}
      </div>
      <Button label="+ Add operational check" className="p-button-outlined p-button-sm" style={{ marginTop: '0.5rem' }} onClick={addCheck} />
    </div>
  );
};

export default OperationalChecksBuilder;
